<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch01">
<div class="chapterHead">
<h2 class="chapterTitle" style="text-indent: 0%;"><span class="bold">A Man from Her Past</span></h2></div>
<div class="chapterBody">
<p class="chapterOpenerText" style="text-indent: 0%;">I think Mother is flirting with a man from her past who is not Father. I say to myself: Mother ought not to have improper relations with this man “Franz”! “Franz” is a European. I say she should not see this man improperly while Father is away! But I am confusing an old reality with a new reality: Father will not be returning home. He will be staying on at Vernon Hall. As for Mother, she is ninety-four years old. How can there be improper relations with a woman of ninety-four? Yet my confusion must be this: though her body is old, her capacity for betrayal is still young and fresh.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781466806276_ch01.vue?33f550ce